import { Box, Chip } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

type ITeamChip = {
  id: string;
  name: string;
  to?: string;
};

export const renderTeamsCell = (teams: Array<string | ITeamChip>) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {teams.map((team) => (
        typeof team === 'string' ? (
          <Chip key={team} label={team} title={team} size="small" />
        ) : (
          <Chip
            key={team.id}
            label={team.name}
            title={team.name}
            size="small"
            clickable={Boolean(team.to)}
            component={team.to ? RouterLink : (child) => child}
            to={team.to}
          />
        )
      ))}
    </Box>
  );
};
